import { useEffect } from "react";
import { scrollToId } from "@/lib/api";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    const tag = document.querySelector('meta[name="description"]');
    if (tag && description) tag.setAttribute("content", description);
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const t = setTimeout(() => scrollToId(id), 800);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [title, description]);
}
